// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.list-menu__list[data-v-21797121] {\n  list-style: none;\n}\n.list-menu__list button[data-v-21797121] {\n  padding: 15px;\n  font-size: 14px;\n  width: 100%;\n  text-align: left;\n}\n.list-menu__list__arrow[data-v-21797121] {\n  margin-right: 5px;\n}\n.focus[data-v-21797121] {\n  background-color: #F9F9FA;\n  cursor: default;\n}\n", ""]);
// Exports
module.exports = exports;
